import { RenderableErrorResponse } from '../../../../../services/exports/Types';
import { batch, useDispatch } from 'react-redux';
import initialDataSlice from '../../../../../store/slices/InitialDataSlice';

const useItemsUnavailableErrorHandler = () => {
  const dispatch = useDispatch();

  const handler = (response: RenderableErrorResponse<number[]>): void => {
    const productIds = response.response.data.payload;

    batch(() => {
      productIds.forEach((productId) =>
        dispatch(
          initialDataSlice.actions.updateProduct({
            id: productId,
            is_available: false,
          }),
        ),
      );
    });
  };

  return handler;
};

export default useItemsUnavailableErrorHandler;
